import { ProductCardStoreContext } from 'product-card/context/ProductCardStoreContext/ProductCardStoreContext'
import type { ProductCardStore } from 'product-card/store/productCardStore'
import { useContext } from 'react'
import { useStore } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

export const useProductCardStore = <T>(
	selector: (store: ProductCardStore) => T
): T => {
	const productCardStoreContext = useContext(ProductCardStoreContext)

	if (!productCardStoreContext) {
		throw new Error(
			'useProductCardStore must be used within ProductCardStoreProvider'
		)
	}

	return useStore(productCardStoreContext, selector)
}

export const useProductCard = () =>
	useProductCardStore(useShallow((state) => state))
